module.exports = __webpack_public_path__ + "static/media/buildingConstruction11.6f7202c3.jpg";